<template>
  <div>
    <b-modal v-model="show" no-close-on-backdrop no-close-on-esc hide-header-close :id="theme" header-class="my-class" size="lg"
      title="痛みの評価：eVAS">
      <div class="row px-3">
        <div class="col-12">
          <div class="text-center">
            <span>患者ID: {{ user.patient_id }}</span>
            <span class="ms-3">患者名: {{ user.information?.fullname }}</span>
          </div>
        </div>
        <div class="mt-2 d-flex content-inpust-custome">
          <span class="align-self-center pe-2">0</span>
        <b-form-input class="align-self-center flex-grow-1 d-flex justify-content-center" style="width: 100mm;"
          v-model="vas" @change="updateVas" type="range" min="0" max="100"></b-form-input>
        <span class="align-self-center ps-2">100</span>
        </div>
        <b-form-input class="container-vas" ref="input" type="number" disabled :value="updateVasValue"></b-form-input>        
      </div>
      <template #modal-footer>
        <div class="w-100 row p-0">
          <div class="d-flex justify-content-between" style="width: 100%;">
            <div style=" width: 49.9%;margin-left: -10px;">
              <b-button class="w-100" type="button" @click="reStartRange()" variant="outline-danger">オールクリアー</b-button>
            </div>
            <div style=" width: 49.9%; margin-right: -10px;">
              <b-button type="button" @click="submit()" class="w-100 btn-lyg" style="padding-left: 2px !important"
                variant="primary">保存</b-button>
            </div>
          </div>
          <div class="col-12 p-0 pt-3">
            <b-button type="button" @click="closeModal()" class="w-100" style="padding-left: 2px !important"
              variant="light">戻る</b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { userMethods } from "@/state/helpers";
import { mixin } from "@/helpers/Vue-Mixin";

export default {
  mixins: [mixin],

  props: ['isShow', 'user'],
  data() {
    return {
      show: false,
      vas: 0,
      updateVasValue: 0,
    };
  },

  watch: {
    isShow: {
      handler(value) {
        this.show = value;
      },
    },
  },

  computed: {
    theme() {
      return this.$store.state.theme;
    },
  },

  methods: {
    ...userMethods,
    updateVas() {
      this.updateVasValue = this.vas;
    },
    reStartRange() {
      this.vas = 0;
      this.updateVasValue = 0;
    },
    closeModal() {
      this.$emit("close");
      this.show = true;
    },
    submit() {
      this.$emit("submit", this.vas);
      this.closeModal();
    }

  },
};
</script>

<style scoped>
.container-vas {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-left: 40%;
  width: 20%;
  height: 30px;
  background-color: #d3d8dd;
  border-radius: 5px;
}

.content-inpust-custome {
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep .modal-header {
  background: #007e41;
  height: 70px;
}

::v-deep .modal-title {
  display: block;
  width: 100%;
  text-align: center;
  padding: 1rem;
  font-weight: 700;
  color: #fff !important;
  font-size: 20px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}
</style>
